import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_98f4c0a7-37e3-4eee-b45d-3c901b2920ec/artifacts/cpmel363_Purpose%20reclaimed%20coaching.png';

export const Footer = () => (
  <footer className="bg-sage-dark text-white/80 py-12 px-6">
    <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3 mb-3">
          <img src={LOGO_URL} alt="Purpose Reclaimed Coaching" className="h-10 w-10 rounded-full object-cover" />
          <h3 className="font-heading text-xl text-white">Purpose Reclaimed Coaching</h3>
        </div>
        <p className="text-sm leading-relaxed text-white/60">
          Faith-led coaching for women healing from trauma, abuse, and limiting beliefs. 
          Empowering you to forgive, heal, and step into your God-given purpose.
        </p>
      </div>
      <div>
        <h4 className="font-heading text-lg text-white mb-3">Quick Links</h4>
        <div className="space-y-2 text-sm">
          <Link to="/coaching" className="block hover:text-gold transition-colors">Coaching</Link>
          <Link to="/purchase" className="block hover:text-gold transition-colors">Ebook Packages</Link>
          <Link to="/workshops" className="block hover:text-gold transition-colors">Workshops</Link>
          <Link to="/free" className="block hover:text-gold transition-colors">Free Resources</Link>
          <Link to="/contact" className="block hover:text-gold transition-colors">Contact</Link>
        </div>
      </div>
      <div>
        <h4 className="font-heading text-lg text-white mb-3">Connect</h4>
        <div className="space-y-2 text-sm">
          <a href="https://www.instagram.com/jan_elle_9494" target="_blank" rel="noopener noreferrer" className="block hover:text-gold transition-colors">Instagram</a>
          <a href="https://www.tiktok.com/@jan62249" target="_blank" rel="noopener noreferrer" className="block hover:text-gold transition-colors">TikTok</a>
          <a href="https://www.facebook.com/mcgowan.charles.janelle" target="_blank" rel="noopener noreferrer" className="block hover:text-gold transition-colors">Facebook</a>
          <a href="https://www.linkedin.com/in/janelle-mcgowan-charles" target="_blank" rel="noopener noreferrer" className="block hover:text-gold transition-colors">LinkedIn</a>
          <a href="mailto:jmcgowancharles@gmail.com" className="block hover:text-gold transition-colors">Email</a>
          <Link to="/links" className="block hover:text-gold transition-colors">All Links</Link>
        </div>
      </div>
    </div>
    <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-white/10 text-center">
      <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} Janelle McGowan-Charles, Purpose Reclaimed Coaching. All rights reserved.</p>
    </div>
  </footer>
);
